/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RealtimeDataTagsBody } from '../../models/realtime-data-tags-body';
import { TagsRealtimeData } from '../../models/tags-realtime-data';

export interface GetTagsRealtimeData$Params {
  
    /**
     * Tags Realtime data options
     */
    body: RealtimeDataTagsBody
}

export function getTagsRealtimeData(http: HttpClient, rootUrl: string, params: GetTagsRealtimeData$Params, context?: HttpContext): Observable<StrictHttpResponse<TagsRealtimeData>> {
  const rb = new RequestBuilder(rootUrl, getTagsRealtimeData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagsRealtimeData>;
    })
  );
}

getTagsRealtimeData.PATH = '/tags/realtime';
